export {add, add as new, add as positive} from './Icon--add.js';
export {addCircleFilled} from './Icon--addCircleFilled.js';
export {addCircle} from './Icon--addCircle.js';
export {api} from './Icon--api.js';
export {apps} from './Icon--apps.js';
export {arrowDecrease} from './Icon--arrowDecrease.js';
export {arrowDownCircle} from './Icon--arrowDownCircle.js';
export {arrowDown} from './Icon--arrowDown.js';
export {arrowIncrease} from './Icon--arrowIncrease.js';
export {arrowLeft, arrowLeft as previous} from './Icon--arrowLeft.js';
export {arrowLeftCircle} from './Icon--arrowLeftCircle.js';
export {arrowRight, arrowRight as next} from './Icon--arrowRight.js';
export {arrowRightCircle} from './Icon--arrowRightCircle.js';
export {arrowUpCircle} from './Icon--arrowUpCircle.js';
export {arrowUpDown} from './Icon--arrowUpDown.js';
export {
  arrowUpRightCircle,
  arrowUpRightCircle as arrowExportCircle,
  arrowUpRightCircle as exportCircle,
} from './Icon--arrowUpRightCircle.js';
export {arrowUpRight} from './Icon--arrowUpRight.js';
export {arrowUp} from './Icon--arrowUp.js';
export {arrowsInward, arrowsInward as collapse} from './Icon--arrowsInward.js';
export {arrowsLoop} from './Icon--arrowsLoop.js';
export {arrowsOutward, arrowsOutward as expand} from './Icon--arrowsOutward.js';
export {
  balance,
  balance as moneyMovement,
  balance as financialActivity,
} from './Icon--balance.js';
export {
  bankLightning,
  bankLightning as payByBank,
} from './Icon--bankLightning.js';
export {bank} from './Icon--bank.js';
export {barChart, barChart as barGraph} from './Icon--barChart.js';
export {billingQuote} from './Icon--billingQuote.js';
export {billing} from './Icon--billing.js';
export {business} from './Icon--business.js';
export {calculator, calculator as plan} from './Icon--calculator.js';
export {calendar} from './Icon--calendar.js';
export {call} from './Icon--call.js';
export {camera} from './Icon--camera.js';
export {cancel, cancel as delete} from './Icon--cancel.js';
export {cancelCircle, cancelCircle as cross} from './Icon--cancelCircle.js';
export {cancelCircleFilled} from './Icon--cancelCircleFilled.js';
export {card} from './Icon--card.js';
export {caretDown} from './Icon--caretDown.js';
export {caretLeft} from './Icon--caretLeft.js';
export {caretRight} from './Icon--caretRight.js';
export {caretUp} from './Icon--caretUp.js';
export {cart} from './Icon--cart.js';
export {certificate} from './Icon--certificate.js';
export {
  change,
  change as recurring,
  change as changeCircle,
} from './Icon--change.js';
export {chat} from './Icon--chat.js';
export {check, check as accept} from './Icon--check.js';
export {checkCircle, checkCircle as checkmark} from './Icon--checkCircle.js';
export {checkCircleFilled} from './Icon--checkCircleFilled.js';
export {chevronDownCircle} from './Icon--chevronDownCircle.js';
export {chevronDown} from './Icon--chevronDown.js';
export {chevronLeftCircle} from './Icon--chevronLeftCircle.js';
export {chevronLeft} from './Icon--chevronLeft.js';
export {chevronRightCircle} from './Icon--chevronRightCircle.js';
export {chevronRight} from './Icon--chevronRight.js';
export {chevronUpCircle} from './Icon--chevronUpCircle.js';
export {chevronUp} from './Icon--chevronUp.js';
export {circle} from './Icon--circle.js';
export {
  clipboardCheck,
  clipboardCheck as compliance,
} from './Icon--clipboardCheck.js';
export {clipboard} from './Icon--clipboard.js';
export {clock} from './Icon--clock.js';
export {cloud} from './Icon--cloud.js';
export {code} from './Icon--code.js';
export {connectPayments} from './Icon--connectPayments.js';
export {control} from './Icon--control.js';
export {convert} from './Icon--convert.js';
export {createCards} from './Icon--createCards.js';
export {createIdentityVerification} from './Icon--createIdentityVerification.js';
export {credit} from './Icon--credit.js';
export {crypto} from './Icon--crypto.js';
export {customerPortal} from './Icon--customerPortal.js';
export {customers} from './Icon--customers.js';
export {customizeBrand} from './Icon--customizeBrand.js';
export {dataExport} from './Icon--dataExport.js';
export {data} from './Icon--data.js';
export {desktop} from './Icon--desktop.js';
export {digitalDollar} from './Icon--digitalDollar.js';
export {disputeSmart} from './Icon--disputeSmart.js';
export {document, document as doc} from './Icon--document.js';
export {download} from './Icon--download.js';
export {dragHandle} from './Icon--dragHandle.js';
export {edit, edit as editCircle} from './Icon--edit.js';
export {email} from './Icon--email.js';
export {explorer} from './Icon--explorer.js';
export {
  exportIcon as export,
  exportIcon as arrowExport,
} from './Icon--export.js';
export {externalTest} from './Icon--externalTest.js';
export {external} from './Icon--external.js';
export {eyeClosed, eyeClosed as hide} from './Icon--eyeClosed.js';
export {eyeOpen, eyeOpen as review, eyeOpen as show} from './Icon--eyeOpen.js';
export {filter} from './Icon--filter.js';
export {fingerprint} from './Icon--fingerprint.js';
export {flag} from './Icon--flag.js';
export {folder} from './Icon--folder.js';
export {gavel, gavel as rule} from './Icon--gavel.js';
export {gift} from './Icon--gift.js';
export {globe} from './Icon--globe.js';
export {gridView} from './Icon--gridView.js';
export {growth} from './Icon--growth.js';
export {guide} from './Icon--guide.js';
export {heartFilled} from './Icon--heartFilled.js';
export {heart} from './Icon--heart.js';
export {help} from './Icon--help.js';
export {history} from './Icon--history.js';
export {home} from './Icon--home.js';
export {identityVerification} from './Icon--identityVerification.js';
export {importIcon as import} from './Icon--import.js';
export {info} from './Icon--info.js';
export {invite} from './Icon--invite.js';
export {invoice} from './Icon--invoice.js';
export {iosShare} from './Icon--iosShare.js';
export {lab, lab as beta} from './Icon--lab.js';
export {lightBulb, lightBulb as insight} from './Icon--lightBulb.js';
export {lightningBolt} from './Icon--lightningBolt.js';
export {link, link as paymentLink} from './Icon--link.js';
export {listView} from './Icon--listView.js';
export {list} from './Icon--list.js';
export {locationPin} from './Icon--locationPin.js';
export {lock} from './Icon--lock.js';
export {menu} from './Icon--menu.js';
export {miniPlayer} from './Icon--miniPlayer.js';
export {mobileWallet} from './Icon--mobileWallet.js';
export {modalWindow} from './Icon--modalWindow.js';
export {more, more as overflow} from './Icon--more.js';
export {moreCircle} from './Icon--moreCircle.js';
export {moved} from './Icon--moved.js';
export {navClock} from './Icon--navClock.js';
export {
  negativeCircle,
  negativeCircle as block,
} from './Icon--negativeCircle.js';
export {negativeCircleFilled} from './Icon--negativeCircleFilled.js';
export {negative} from './Icon--negative.js';
export {note} from './Icon--note.js';
export {notifications} from './Icon--notifications.js';
export {office} from './Icon--office.js';
export {openLock} from './Icon--openLock.js';
export {orgChart} from './Icon--orgChart.js';
export {panelArrowLeft} from './Icon--panelArrowLeft.js';
export {panelArrowRight} from './Icon--panelArrowRight.js';
export {pane} from './Icon--pane.js';
export {paperclip} from './Icon--paperclip.js';
export {pause} from './Icon--pause.js';
export {payment, payment as charge} from './Icon--payment.js';
export {payout} from './Icon--payout.js';
export {person, person as customer} from './Icon--person.js';
export {
  personWithKey,
  personWithKey as passkey,
} from './Icon--personWithKey.js';
export {phone} from './Icon--phone.js';
export {pieChart, pieChart as fee} from './Icon--pieChart.js';
export {pin, pin as pinOutline} from './Icon--pin.js';
export {pinFilled, pinFilled as pinAdd} from './Icon--pinFilled.js';
export {ping} from './Icon--ping.js';
export {platform} from './Icon--platform.js';
export {playCircle} from './Icon--playCircle.js';
export {play} from './Icon--play.js';
export {product, product as productSubscription} from './Icon--product.js';
export {qrCode} from './Icon--qrCode.js';
export {recurringInvoice} from './Icon--recurringInvoice.js';
export {refresh, refresh as refreshCircle} from './Icon--refresh.js';
export {refund, refund as refundCircle} from './Icon--refund.js';
export {reporting} from './Icon--reporting.js';
export {resourceSharing} from './Icon--resourceSharing.js';
export {rocket, rocket as deploy} from './Icon--rocket.js';
export {sandbox} from './Icon--sandbox.js';
export {search} from './Icon--search.js';
export {send} from './Icon--send.js';
export {settings} from './Icon--settings.js';
export {share} from './Icon--share.js';
export {
  shield,
  shield as disputeProtection,
  shield as risk,
} from './Icon--shield.js';
export {shieldCheck} from './Icon--shieldCheck.js';
export {shoppingBag, shoppingBag as order} from './Icon--shoppingBag.js';
export {signOut} from './Icon--signOut.js';
export {signed} from './Icon--signed.js';
export {soundOff} from './Icon--soundOff.js';
export {soundOn} from './Icon--soundOn.js';
export {sparkle} from './Icon--sparkle.js';
export {spinner} from './Icon--spinner.js';
export {starFilled} from './Icon--starFilled.js';
export {star} from './Icon--star.js';
export {stepForward} from './Icon--stepForward.js';
export {subscription} from './Icon--subscription.js';
export {support} from './Icon--support.js';
export {tag, tag as coupon} from './Icon--tag.js';
export {tasks} from './Icon--tasks.js';
export {terminal} from './Icon--terminal.js';
export {thumbsDown} from './Icon--thumbsDown.js';
export {thumbsUp} from './Icon--thumbsUp.js';
export {topup} from './Icon--topup.js';
export {transfer} from './Icon--transfer.js';
export {trash} from './Icon--trash.js';
export {trial} from './Icon--trial.js';
export {truck} from './Icon--truck.js';
export {upload} from './Icon--upload.js';
export {usage} from './Icon--usage.js';
export {vault, vault as reserve, vault as safe} from './Icon--vault.js';
export {video} from './Icon--video.js';
export {wallet, wallet as source} from './Icon--wallet.js';
export {
  warningCircle,
  warningCircle as dispute,
  warningCircle as earlyFraudWarning,
} from './Icon--warningCircle.js';
export {warning} from './Icon--warning.js';
export {webhook} from './Icon--webhook.js';
export {website} from './Icon--website.js';
export {wifi} from './Icon--wifi.js';
export {withdrawal} from './Icon--withdrawal.js';
